import styled from "styled-components";

interface CustomCheckboxProps {
    isChecked: boolean;
    disabled?: boolean;
    onClick?: () => void;
}

export const CustomCheckbox: React.FC<CustomCheckboxProps> = ({ isChecked, disabled, onClick }) => {
    return (
        <StyledCheckbox isChecked={isChecked} disabled={disabled} onClick={onClick}>
            <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
                <path
                    d="M1 5L4.5 8.5L11 1"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </StyledCheckbox>
    );
};

const StyledCheckbox = styled.div<CustomCheckboxProps>`
    width: 20px;
    height: 20px;
    border: 2px solid ${(p) => (p.isChecked ? "transparent" : p.theme.colors.gray_6_5)};
    border-radius: 4px;
    cursor: pointer;
    background: ${(p) => (p.isChecked ? p.theme.colors.main : "transparent")};
    opacity: ${(p) => (p.disabled ? 0.5 : 1)};
    pointer-events: ${(p) => (p.disabled ? "none" : "auto")};
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        opacity: ${(p) => (p.isChecked ? 1 : 0)};
        transition: opacity 0.2s ease;
    }
`;
